import type { ActivityType } from '../typings'
import { isAPIError, put } from '@user/store/services/crud'
import { baseUrl } from '../constants'
import { toast } from '@sales-center/components'
import { activityTypeUpdatedActionCreator } from '../state'

export async function updateActivityType(data: ActivityType) {
  const response = await put(baseUrl, data)
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to update Activity Type')
    }
    return activityTypeUpdatedActionCreator()
  }

  return activityTypeUpdatedActionCreator(result)
}
